import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yourApps: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps',
		defaultMessage: 'Your apps',
		description: 'Message for installed global apps heading in the Apps menu items',
	},
});
